import React, {useState} from "react";
import {
    Box, Typography, TextField, Button, InputAdornment, Divider
} from "@mui/material";
import { useOutletContext, } from "react-router-dom";
import { esignIcons } from "../../components/Esign/icons";

const Premium = ({type}) => {
    const { open } = useOutletContext();
    const typeDescriptions = {
        dashboard: "Get a quick overview of your eSign activity, credits, and recent document statuses — all in one place.",
        workflow: "Easily manage and automate document signing with workflows — perfect for teams and frequent senders.",
        archive: "View and manage your previously signed documents stored in the archive.",
        trash: "Access deleted documents and restore if needed.",
        "api-integration": "Integrate document signing directly into your apps using our powerful API.",
        "our-products": "Explore our full suite of digital document and eSign solutions.",
    };

    return (
      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          width: open ? "calc(100% - 240px)" : "calc(100% - 100px)",
          marginLeft: open ? "240px" : "100px",
          transition: "margin 0.3s ease",
          height: "100vh",
          display: "flex",
          background: "#f9f9f9",
        }}
      >
        <Box
          mt={10}
          style={{
            borderRadius: "12px",
            textAlign: "center",
            background: "#fff",
            width: "100%",
            height: "calc(100% - 73px)",
            marginLeft: open ? "" : "1em",
          }}
        >
            <Box sx={{ display: "flex", alignItems:'center', justifyContent: "space-between", padding: "25px" }}>
                <Typography noWrap component="p" sx={{ fontSize: '20px', fontWeight: 500, lineHeight: '20px', color: "#1D1D1D", ml: 2 }}>
                    {type}
                </Typography>
                <Box sx={{  }}>
                    <TextField
                        placeholder="Search..."
                        type="number"
                        variant="outlined"
                        // onChange={handleSearchChange}
                        onKeyDown={(e) => {
                            if (["e", "E", "+", "-", "."].includes(e.key)) {
                              e.preventDefault();
                            }
                        }}
                        onPaste={(e) => {
                            const paste = e.clipboardData.getData('text');
                            if (!/^\d+$/.test(paste)) {
                              e.preventDefault();
                            }
                        }}
                        sx={{
                        boxSizing: "border-box",
                        borderRadius: "10px",
                        backgroundColor: "#fff",
                        borderColor: "#E8E8E9",
                        borderWidth: "5px",
                        "& .MuiOutlinedInput-root": {
                            borderColor: "#E8E8E9",
                            backgroundColor: "none",
                            "&:hover fieldset": {
                            borderColor: "#E8E8E9",
                            },
                            "&.Mui-focused fieldset": {
                            borderColor: "#E8E8E9",
                            },
                        },
                        }}
                        InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                            {esignIcons.searchIcon}
                            </InputAdornment>
                        ),
                        sx: { 
                            borderRadius: "10px",
                            width: 410,
                            height: 40,
                            fontSize: "16px",
                            fontWeight: "500",
                            "& input::-ms-reveal, & input::-ms-clear": {
                                display: "none",
                            },
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                display: "none",
                                WebkitAppearance: "none",
                                margin: 0,
                            },
                            "& input[type=number]": {
                                MozAppearance: "textfield",
                            },
                        },
                        }}
                    />
                </Box>
            </Box>
            <Divider />
            <Box
            sx={{
                flexGrow: 1,
                p: "0",
                width: open ? "calc(100% - 288px)" : "calc(100% - 164px)",
                transition: "margin 0.3s ease",
                height: "calc(100% - 103px)",
                display: "flex",
                gap: 3,
                position: "absolute",
                top: 103,
            }}
            >
                <Box
                    mt={10}
                    style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "12px",
                    textAlign: "center",
                    width: "100%",
                    height: "calc(100% - 16px)",
                    marginTop: 0,
                    background: "#8F8F8F33",
                    backdropFilter: "blur(5px)",
                    }}
                >
                    <Box sx={{ width: 480, height: 320, display: "flex", flexDirection: "column", padding: "23px 51px", alignItems: "center", background: "#fff", borderRadius: "18px" }}>
                    <img src={`${process.env.PUBLIC_URL}/images/premium.svg`} alt="Premium" />
                    <Typography variant="caption" sx={{ fontSize: "18px", fontWeight: "600", color: "#000000" }}>
                        Upgrade to Premium
                    </Typography>
                    <Typography variant="caption" sx={{ fontSize: "14px", fontWeight: "400", color: "#000000" }}>
                        {typeDescriptions[type] || ""}
                    </Typography>
                    <Button variant="contained" sx={{ mt: "auto", width: '172px', height: 46, color: "#FFFFFF", background: "linear-gradient(to right, #2257AD, #B01121)", textTransform: "none", fontSize: "16px", borderRadius: "12px", border: "none", boxShadow: "none", fontWeight: "500",}} >
                        Go Premium
                    </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
      </Box>
    );
};

export default Premium;
